module.exports = Object.freeze({

    REQUIRED_PARAMS_ERROR_TYPE: 0,
    VERIFICATION_CODE_ERROR_TYPE: 1,
    PASSWORD_RULES_ERROR_TYPE: 2,
    WRONG_TEMP_PASSWORD_TYPE: 3,

});